import axios from "axios";
import Vue from "vue";
import { BASEURL } from "@/config/index";
import { getCinemaBaseURL } from "@/services/Api";

export default (params = {}) => {
  const { cinema_id = null } = params;

  // console.log("params", { params, cinema_id });

  let baseURL = getCinemaBaseURL(cinema_id);

  // console.log("baseURL", baseURL);

  const instance = axios.create({
    baseURL: baseURL || BASEURL,
  });

  let JWT = window.localStorage.getItem("JWT_TOKEN");
  if (JWT) {
    instance.defaults.headers.common["Authorization"] = JWT;
  }

  instance.interceptors.response.use(
    function (response) {
      // Do something with response data
      return response;
    },
    function (error) {
      // Do something with response error
      if (error && error.response && error.response.status == 403) {
        Vue.toasted.show("You are not authorized");
      } else if (error && error.response && error.response.status == 401) {
        localStorage.clear();
        Vue.cookie.delete("BRHSID");
        vmVue.$router.push({
          path: "/", // '/go-to-login'
        });
      } else {
        return Promise.reject(error);
      }
    }
  );
  return instance;
};



// WEBPACK FOOTER //
// ./src/services/Api_extra.js